import React, { createContext, useCallback, useMemo, useState } from "react";

export const UiContext = createContext(null);

function readInitialMode() {
  const v = localStorage.getItem("aw_theme_mode");
  if (v === "dark" || v === "light") return v;
  return "light";
}

export function UiProvider({ children }) {
  const [mode, setMode] = useState(readInitialMode());

  const setThemeMode = useCallback((next) => {
    const m = next === "dark" ? "dark" : "light";
    localStorage.setItem("aw_theme_mode", m);
    setMode(m);
  }, []);

  const toggleThemeMode = useCallback(() => {
    setThemeMode(mode === "dark" ? "light" : "dark");
  }, [mode, setThemeMode]);

  const value = useMemo(
    () => ({
      mode,
      setThemeMode,
      toggleThemeMode,
      isDark: mode === "dark",
    }),
    [mode, setThemeMode, toggleThemeMode]
  );

  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
}


